import { useDataValue, useDataChange } from 'Simple/Data.js'

/** @type {import('Simple/types.js').useDataOnChange} */
export default function useDataOnChange(props) {
  let documentTemplateId = useDataValue({
    viewPath: props.viewPath,
    context: 'action',
    path: 'document_template_id',
  })
  let setActionDocumentTemplateId = useDataChange({
    context: 'action',
    path: 'document_template_id',
    viewPath: props.viewPath,
  })

  return function onChange(value) {
    if (!documentTemplateId) return
    // Check if action's document template exists in this location templates.
    // It might not if we consider the copy of automations between locations.
    let isDocumentTemplatePresent = value?.find(
      item => item.id === documentTemplateId
    )
    if (!isDocumentTemplatePresent) {
      setActionDocumentTemplateId(null)
      return
    }
  }
}
